export const useJquery = () => {
  const addJquery = () => {
    const jqueryScript = document.createElement('script')
    jqueryScript.setAttribute('src', 'https://code.jquery.com/jquery-3.6.0.min.js')
    jqueryScript.setAttribute('integrity', 'sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4=')
    jqueryScript.setAttribute('crossorigin', 'anonymous')
    document.body.appendChild(jqueryScript)
  }

  return {
    addJquery
  }
}